<template>
  <!-- Search -->
  <div class="bg-body-dark">
    <div class="content">
      <div class="pt-5">
        <h2 class="mb-2 text-center">
          {{$t('accountProfile.home.accountProfileScore')}}
        </h2>
        <h4 class="font-w300 text-muted push text-center">
        </h4>
      </div>
      <form v-on:submit.prevent="getResults()">
        <div class="form-group">
          <input v-model="search" type="text" class="form-control form-control-lg py-3 text-center" :placeholder="$t('accountProfile.home.enterAccountHere')">
        </div>
        <div class="form-group row items-push mb-0 justify-content-center">
          <div class="col-sm-6 col-md-4">
            <button type="submit" class="btn btn-primary btn-block">{{$t('accountProfile.home.search')}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- END Search -->
</template>

<script>
export default {
  name: 'Home',
  computed: {
    search: {
      // getter
      get () {
        return this.$store.state.filter.search
      },
      // setter
      set (value) {
        this.$store.commit('setSearch', value)
      }
    }
  },
  methods: {
    getResults () {
      this.$router.push({
        name: 'AccountProfileResults',
        params: { account: this.search }
      })
    }
  }
}
</script>

<style scoped>

</style>
